<template>
  <div class="page">
    <header-bar navStyle="padding-left:.266rem;padding-right:.266rem;">
      <span>{{ $t(objSave.centerTitle) }}</span>
      <span slot="right" @click="Save">{{ $t("share.Save") }}</span>
    </header-bar>
    <div class="page-content">
      <div class="addressInfos">
        <div class="addressInfos-wrapper">
          <div class="addressInfos-item">
            <div>
              <input v-model="model.ContactName" type="text" :placeholder="$t('placeholders.UserName')" />
            </div>
            <div>{{ $t("mall.UserName") }}</div>
          </div>
          <div class="border_bottom"></div>
          <div class="addressInfos-item">
            <div>
              <input v-model="model.ContactPhone" type="tel" :placeholder="$t('placeholders.Phone')" />
            </div>
            <div>{{ $t("mall.Phone") }}</div>
          </div>
          <div class="border_bottom"></div>
          <div class="addressInfos-item">
            <div @click="showPicker">
              <div>{{ selectedText[0] }}</div>
              <img style="width:0.372rem;vertical-align: middle" src="/static/img/left1.png" />
            </div>
            <div>{{ $t("mall.City") }}</div>
            <!-- <div style=" position: absolute;top: 0;right: 0;width: 0.665rem;text-align: right;">
            </div> -->
            <!-- <input @click="showPicker" type="text" :placeholder="$t('placeholders.SearchZones')" /> -->
          </div>
          <div class="border_bottom"></div>
          <div class="addressInfos-item">
            <div>
              <input v-model="model.Address" type="text" :placeholder="$t('placeholders.RecipientAddress')" />
            </div>
            <div>{{ $t("mall.Address") }}</div>
          </div>
          <div class="border_bottom"></div>
          <div class="addressInfos-item">
            <div>
              <input v-model="model.PostCode" type="text" :placeholder="$t('placeholders.RecipientPostcode')" />
            </div>
            <div>{{ $t("mall.Postcode") }}</div>
          </div>
        </div>
        <!-- <div class="setAddress" v-if="model.AddressID!=''">
          <span>{{$t('system_newaddress_shezhimorendizhi')}}</span>
          <switch-option name="switch" @click="clickAutoPlay" :value="isAutoPlay" @update:value="updateAutoPlay"></switch-option>
        </div> -->
        <div class="delectressInfos" v-if="ContactID" @click="Delete">{{ $t("system_newaddress_shanchu") }}</div>
        <!-- <img style="height:0.638rem" src="/static/img/delete.png" @click="Delete" /> -->
      </div>
    </div>
    <cityPicker ref="picker" @select="handleSelect(1, arguments)" :data="AreaDatas" :selectedIndex="selectedIndex" :cancelTxt="cancelTxt" :confirmTxt="confirmTxt"></cityPicker>
  </div>
</template>
<script>
  import cityPicker from "./modules/city-picker.vue";
  import SwitchOption from "./modules/switch-option.vue";
  import navBar from "./modules/navBar.vue";
  import { YesOrNo } from "@/model/Base";
  import UserService from "@/service/UserService";
  import baseService from "@/service/baseService";
  import { Dialog } from "vant";
  export default {
    name: "NewAddress",
    data() {
      return {
        selectedIndex: [0, 0, 0],
        cancelTxt: "share.cancelTxt",
        confirmTxt: "share.confirmTxt",
        objSave: {
          centerTitle: "mall.AddCommonAddresses",
          rightTitle: {
            isShow: true,
            type: "button",
            label: "share.Save",
            fnName: "fnSave",
          },
        },
        model: {
          Address: "",
          ContactID: "",
          AddressName: "",
          CityID: "11181",
          ContactName: "",
          ContactPhone: "",
          CreateTime: "",
          CreateTimeEnd: "",
          CreateUserID: "",
          CreateUserName: "",
          DistrictID: "31645",
          FullAddress: "",
          IsDefault: 1150,
          PostCode: "",
          ProvinceID: "1321",
          RoleID: "",
          UpdateTime: "",
          UpdateTimeEnd: "",
          UpdateUserID: "",
          UpdateUserName: "",
        },
        SearchZoneList: {
          CountryID: 151,
          PageSize: 100000,
        },
        isAutoPlay: false,
        ProvinceData: [],
        CityData: [],
        DistrictData: [],
        AreaDatas: [],
        selectedText: [],
      };
    },
    computed: {
      CompanyID() {
        return this.profile.CompanyID;
      },
      UserID() {
        return this.profile.UserID;
      },
      ContactID() {
        return this.$route.query.ContactID;
      },
      // AreaDatas() {
      //   let __self = this;
      //   let Data = []
      //   if (__self.ProvinceData.length > 0 && __self.CityData.length > 0 && __self.DistrictData.length > 0) {
      //     Data.push(__self.ProvinceData, __self.CityData, __self.DistrictData)
      //   }
      //   return Data
      // }
    },
    watch: {
      "model.IsDefault"(newVal) {
        let __self = this;
        if (newVal == YesOrNo.Yes) {
          __self.isAutoPlay = true;
        } else {
          __self.isAutoPlay = false;
        }
      },
    },
    created() {
      let __self = this;
    },
    mounted() {
      let __self = this;
      __self.__init();
      __self.__CityData();
    },
    methods: {
      __CityData() {
        let __self = this;
        const ProvinceData = new Promise((resolve, reject) => {
          __self.SearchZoneList.ZoneType = "1445";
          (__self.SearchZoneList.Props = "ZoneID,CityID,ZoneName,ZoneUpper"),
            baseService.getZoneList(__self.SearchZoneList).then(function(json) {
              if (json.isSucc) {
                resolve(json.result.entities);
              }
            });
        });
        const CityData = new Promise((resolve, reject) => {
          __self.SearchZoneList.ZoneType = "1444";
          (__self.SearchZoneList.Props = "ZoneID,CityID,ZoneName,ZoneUpper"),
            baseService.getZoneList(__self.SearchZoneList).then(function(json) {
              if (json.isSucc) {
                resolve(json.result.entities);
              }
            });
        });
        const DistrictData = new Promise((resolve, reject) => {
          __self.SearchZoneList.ZoneType = "1449";
          (__self.SearchZoneList.Props = "ZoneID,CityID,ZoneName,ZoneUpper"),
            baseService.getZoneList(__self.SearchZoneList).then(function(json) {
              if (json.isSucc) {
                resolve(json.result.entities);
              }
            });
        });
        Promise.all([ProvinceData, CityData, DistrictData]).then(resultLists => {
          __self.AreaDatas = resultLists;
          resultLists[0].map((item, index) => {
            if (item.ZoneID == __self.model.ProvinceID) {
              __self.selectedIndex[0] = index;
              __self.selectedText[0] = item;
              let GroupCity = _.groupBy(resultLists[1], function(o) {
                return o.ZoneUpper;
              });
              GroupCity[item.ZoneID].map((city, cityIndex) => {
                if (city.CityID == __self.model.CityID) {
                  __self.selectedIndex[1] = cityIndex;
                  __self.selectedText[1] = city;
                  let District = _.groupBy(resultLists[2], function(o) {
                    return o.ZoneUpper;
                  });
                  District[city.CityID].map((District, DistrictIndex) => {
                    if (District.ZoneID == __self.model.DistrictID) {
                      __self.selectedIndex[2] = DistrictIndex;
                      __self.selectedText[2] = District;
                    }
                  });
                }
              });
            }
          });
          let text = [];
          for (let i = 0; i < __self.selectedText.length; i++) {
            text.push(__self.selectedText[i].ZoneName);
          }
          __self.selectedText = [];
          __self.selectedText.push(text.join(","));
        });
      },
      showPicker() {
        let __self = this;
        if (__self.AreaDatas.length > 0) {
          let picker = this.$refs.picker;
          picker.show();
        }
      },
      __init() {
        let __self = this;
        if (__self.ContactID != undefined && __self.CompanyID != undefined) {
          __self.model.ContactID = __self.ContactID;
          UserService.getContactInfo(__self.model.ContactID).then(function(json) {
            if (json.isSucc) {
              if (json.result.ProvinceID == 0) {
                json.result.ProvinceID = 1321;
              }
              if (json.result.CityID == 0) {
                json.result.CityID = 11181;
              }
              if (json.result.DistrictID == 0) {
                json.result.DistrictID = 31645;
              }
              __self.model = json.result;
              if (__self.model.IsDefault == YesOrNo.Yes) {
                __self.isAutoPlay = true;
              } else {
                __self.isAutoPlay = false;
              }
            }
          });
        }
      },
      Save() {
        let __self = this;
        __self.model.RoleID = __self.UserID;
        UserService.saveContactInfo(__self.model).then(json => {
          if (json.isSucc) {
            if (__self.model.ContactID) {
              this.$root.$toast.success(__self.$t("share.succ.AddSucc"));
            } else {
              this.$root.$toast.success(__self.$t("share.succ.ModifySucc"));
            }
            history.back();
          }
        });
      },
      handleSelect(index, args) {
        let __self = this;
        let text = [];
        __self.selectedText = [];
        for (let i = 0; i < args[2].length; i++) {
          if (args[2][i]) {
            text.push(args[2][i].ZoneName);
          }
        }
        __self.model.ProvinceID = args[2][0].ZoneID;
        __self.model.CityID = args[2][1].ZoneID;
        __self.model.DistrictID = args[2][2].ZoneID;
        __self.selectedText.splice(index, 1, text.join(","));
      },
      updateAutoPlay(val) {
        this.isAutoPlay = val;
      },
      clickAutoPlay() {
        // let __self = this;
        // UserService.Updateaddress(__self.AddressID).then(function (json) {
        //   if (json.isSucc) {
        //     this.$root.$toast.success(json.data.message, 'succ');
        //     __self.__init();
        //   }
        // })
      },
      Delete() {
        let __self = this;
        this.$dialog.confirm({
          message: this.$root.$t("share.confirm.YesOrNoDelect"),
          closeOnPopstate: true,
        })
          .then(() => {
            UserService.deleteContactInfo(__self.ContactID).then(json => {
              if (json.isSucc) {
                this.$root.$toast.success(this.$root.$t("share.succ.DeleteSucc"));
                history.back();
              }
            });
          })
          .catch(() => {});
      },
    },
    components: {
      navBar,
      SwitchOption,
      cityPicker,
    },
  };
</script>
<style scoped>
  .header-menu {
    background-color: #12a3ff;
  }

  .page-content {
    top: 2.12rem;
  }

  .addressInfos {
    width: 100%;
  }

  .delectressInfos {
    text-align: center;
    background-color: #12a3ff;
    margin: 0.798rem auto;
    width: 7.98rem;
    height: 1.064rem;
    line-height: 1.064rem;
    color: #fff;
    border-radius: 0.106rem;
  }

  .addressInfos-wrapper {
    padding: 0.266rem;
    background-color: #fff;
  }

  /* .addressInfos-item {
    border-bottom: 0.01rem solid #f5f5f5;
    height: 1.064rem;
    display: flex;
    align-items: center;
  }

  .addressInfos-item label {
    min-width: 2.660rem;
    display: inline-block;
    height: 100%;
    display: flex;
    align-items: center;
  } */

  .addressInfos-item {
    position: relative;
  }

  .addressInfos-item > div {
    height: 1.064rem;
    line-height: 1.064rem;
  }

  .addressInfos-item > div:first-child {
    margin-left: 1.995rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .addressInfos-item > div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 1.995rem;
  }

  .setAddress {
    margin-top: 0.532rem;
    display: flex;
    height: 1.197rem;
    padding: 0 0.266rem;
    background-color: #fff;
    justify-content: space-between;
    align-items: center;
  }

  .addressInfos-item input {
    height: 100%;
    border: none;
    width: 100%;
  }

  .addressInfos-item input:focus {
    outline: none;
  }
</style>
